import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import {
	Container,
	Button,
	Col,
	Card,
	CardBody,
	CardTitle,
} from "reactstrap"
import { Link } from "react-router-dom"
import { ToastContainer } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withRouter } from "../../components/Common/withRouter"
import CommonSettingsEditForm from "./CommonSettingsEditForm";

// Utilities
import {
	createNotificationHelpers,
	updateCommonSettings,
	fetchMerchantInfo,
} from "../utils";

class SettingEdit extends Component {
	constructor(props) {
		super(props)
		this.state = {
			store_domain: "",
			is_campaign_links: false,
			is_coupon_blocker: false,
			is_smart_discount: false,
			loading: false,
			store_details: props.location?.state?.data?.store_details || {},
			store_status: "",
		}

		// Initialize notification helpers
		const notifications = createNotificationHelpers();
		this.notify_error = notifications.notify_error;
		this.notify_success = notifications.notify_success;
	}

	componentDidMount() {
		const locationState = this.props.location?.state;
		const data = locationState?.data || this.props.location?.data;

		if (data && data.store_domain) {
			const { store_domain, store_details, store_details: { is_campaign_links, is_coupon_blocker, is_smart_discount } = {}, store_status } = data;
			this.setState({
				store_domain,
				is_campaign_links: is_campaign_links ?? false,
				is_coupon_blocker: is_coupon_blocker ?? false,
				is_smart_discount: is_smart_discount ?? false,
				store_details: { ...store_details },
				store_status
			});
			return;
		}

		// Fetch data from API if accessed via query parameter
		const params = new URLSearchParams(this.props.location?.search || '');
		const storeFromQuery = params.get('store');
		if (storeFromQuery) {
			this.setState({ store_domain: storeFromQuery, loading: true });
			this.loadMerchantData(storeFromQuery);
			return;
		}
	}

	/**
	 * Loads merchant data from API and updates state
	 */
	loadMerchantData = async (storeDomain) => {
		const merchantData = await fetchMerchantInfo(storeDomain, this.notify_error);

		if (merchantData) {
			const store_details = merchantData.store_details || merchantData;
			const { is_campaign_links, is_coupon_blocker, is_smart_discount } = store_details;

			this.setState({
				store_domain: storeDomain,
				is_campaign_links: is_campaign_links ?? false,
				is_coupon_blocker: is_coupon_blocker ?? false,
				is_smart_discount: is_smart_discount ?? false,
				store_details: { ...store_details },
				store_status: merchantData.store_status || "",
				loading: false
			});
		} else {
			this.setState({ loading: false });
		}
	}

	/**
	 * Handles form submission
	 */
	handleValidSubmit = async (e) => {
		e.preventDefault();
		const { store_domain, is_campaign_links, is_coupon_blocker, is_smart_discount } = this.state;
		console.log(store_domain, is_campaign_links, is_coupon_blocker, is_smart_discount);

		const success = await updateCommonSettings(
			store_domain,
			is_campaign_links,
			is_coupon_blocker,
			is_smart_discount,
			this.notify_error
		);

		if (success) {
			this.setState({ loading: true });
			this.notify_success("Setting information has been updated successfully!");
		}
	}

	handleInputChange = (e) => {
		const { name, checked } = e.target;
		this.setState({
			[name]: checked
		})
	}

	render() {
		const { store_domain, store_details, store_status, loading } = this.state;
		return (
			<React.Fragment>
				<div className="page-content">
					<Helmet>
						<title>Veeper | AP - Settings Edit</title>
					</Helmet>
					<Container fluid>
						<Breadcrumbs
							title={("Settings Edit")}
							breadcrumbItem={("Settings")}
						/>
						<ToastContainer />
						<Col md={12}>
							<Card>
								<CardBody>
									<CardTitle className="h4"></CardTitle>
									<Link
										to={{
											pathname: "/merchant-details",
											search: store_domain ? `?store=${encodeURIComponent(store_domain)}` : undefined,
											state: { data: (store_details && Object.keys(store_details).length > 0) ? store_details : { store_domain }, storeStatus: store_status }
										}}
										style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
									>
										<Button className="btn btn-dark">
											<i className="fa fa-arrow-left"></i> Store Details
										</Button>
									</Link>

									<CommonSettingsEditForm
										store_domain={store_domain}
										is_campaign_links={this.state.is_campaign_links}
										is_coupon_blocker={this.state.is_coupon_blocker}
										is_smart_discount={this.state.is_smart_discount}
										onInputChange={this.handleInputChange}
										onSubmit={this.handleValidSubmit}
									/>
								</CardBody>
							</Card>
						</Col>

					</Container>
				</div>
			</React.Fragment>
		)
	}
}

SettingEdit.propTypes = {
	t: PropTypes.any
}
export default withRouter(SettingEdit)
